import { FC } from 'react'
import styled from 'styled-components'
import { HorizontalTitledProductsSlider } from '@/components/organisms/productsSlider'
import {
  ShowProductModal,
  withProductDetailPopup
} from '@/HOC/withProductDetailPopup'
import {
  HorizontalTitledProductsSliderFetcher,
  TitleType
} from '@/components/organisms/productsSlider/horizontalTitledProductsSlider'
import useGraphQl from 'hooks/useGraphQl'
import { Sdk } from '@/network/graphql.g'
import { convertAPIProductToProduct } from '@/types/bridgeProduct'
import { Flex } from '@/components/atoms/Grid'
import { makeFilterInputFromQuery } from '@/providers/filterProvider/parsingFilters'
import { parse, ParsedUrlQuery } from 'querystring'

type PostDetailBestsellerSliderProps = {
  showProductModal?: ShowProductModal
  productFilter: string
  isCampaign: boolean
  isCategory: boolean
}

const PostDetailSlider: FC<PostDetailBestsellerSliderProps> = ({
  showProductModal,
  productFilter,
  isCampaign,
  isCategory
}) => {
  const { request } = useGraphQl()

  const [pathWithoutQuery, query] = productFilter
    ? productFilter.split('?')
    : ''
  const queryParams: ParsedUrlQuery = parse(query)
  const filter = makeFilterInputFromQuery(queryParams)

  const idMatch = pathWithoutQuery?.match(/\/(\d+)$/)
  const categoryOrCampaignId = idMatch ? idMatch[1] : null

  const productFiltersForBlogFetcher = async (): Promise<
    Omit<HorizontalTitledProductsSliderFetcher, 'algorithm'>
  > => {
    if (!categoryOrCampaignId) {
      return { list: '', products: [] }
    }

    if (isCategory) {
      const result = await request(
        (sdk: Sdk) => ({
          method: sdk.getFirstProductsForCategory,
          variables: {
            limit: 10,
            id: categoryOrCampaignId,
            filter,
            page: 1,
            withFilterAndProductsCount: false
          }
        }),
        true
      )
      return {
        list: result.response?.category?.description,
        products:
          result.response?.categoryProducts?.products?.map((product) =>
            convertAPIProductToProduct(product)
          ) ?? []
      }
    }

    if (isCampaign) {
      const result = await request(
        (sdk: Sdk) => ({
          method: sdk.getFirstProductsForCampaign,
          variables: {
            limit: 10,
            id: categoryOrCampaignId,
            filter,
            page: 1,
            withFilterAndProductsCount: false
          }
        }),
        true
      )
      return {
        list: result.response?.campaign?.description ?? '',
        products:
          result.response?.campaignProducts?.products?.map((product) =>
            convertAPIProductToProduct(product)
          ) ?? []
      }
    }

    return { list: '', products: [] }
  }

  return (
    <>
      <StyledWrapper>
        <HorizontalTitledProductsSlider
          action={showProductModal}
          titleType={TitleType.recommended}
          slideItemsCount={{ desktop: 3, tablet: 3, mobile: 2 }}
          fetcher={productFiltersForBlogFetcher}
          swrKey={categoryOrCampaignId}
          useCache={false}
        />
      </StyledWrapper>
    </>
  )
}

export default withProductDetailPopup(PostDetailSlider)

const StyledWrapper = styled(Flex)`
  flex-direction: column;
  width: 100%;
  padding-bottom: 25px;
  & h1 {
    font-size: 22px;
  }
`
